import { Venue } from "../../types/venue";
import { diff_in_days } from "./dates/diff_in_days";

export const MAX_DAYS_TO_BE_NEW = 30


export const isNewVenue = (venue: Venue) : boolean => {
  return -diff_in_days(venue.first_published_at) < MAX_DAYS_TO_BE_NEW
}

export const getNewArrivals = (venues: Venue[]) => {
  return venues.filter(
    (venue) => isNewVenue(venue)
  )
};